import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home';
import GatewayStatus from '../views/gateway/GatewayStatus';
import Settings from '../views/settings/Settings';

import TeamHome from '../views/TeamHome';
import NotFound from '../views/NotFound';
import assetRoutes from './asset-routes';
import zoneRoutes from './zone-routes';
import teamRoutes from './team-routes';
import workspaceRoutes from './workspace-routes';
import dashboardRoutes from './dashboard-routes';
import facilitiesRoutes from './facilities-routes';
import temperatureRoutes from './temperature-routes';
import nbIotRoutes from './nb-iot-routes';
import trackingRoutes from './tracking-routes';
import { routeNames } from '../constants';
import pageViewTracking from '../mixins/event-tracking/mix-panel/page-view-tracking';
import shipmentRoutes from './shipment-routes';
import notificationRoutes from './notification-routes';
import exhibitionRoutes from './exhibition-routes';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: routeNames.home,
    component: Home,
  },
  {
    path: '/not-found',
    name: routeNames.notFound,
    component: NotFound,
  },
  ...trackingRoutes,
  {
    path: '/gateway',
    name: routeNames.gateway.status,
    component: GatewayStatus,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      allowTokenAuth: true, // allow route to be viewed with token in the URL
      noLayout: true,
    },
  },
  ...nbIotRoutes,
  ...exhibitionRoutes,
  {
    path: '/:teamId',
    name: routeNames.teamHome,
    redirect: { name: routeNames.assets.list },
    props: true,
    component: TeamHome,
    children: [
      ...notificationRoutes,
      ...shipmentRoutes,
      ...assetRoutes,
      ...zoneRoutes,
      ...teamRoutes,
      ...workspaceRoutes,
      ...dashboardRoutes,
      ...facilitiesRoutes,
      ...temperatureRoutes,
      {
        path: 'settings',
        name: routeNames.settings,
        component: Settings,
        meta: {
          noTopNav: true,
        },
      },
    ],
  },
  {
    path: '*',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // Mixpanel analytics for tracking page views
  if (to.fullPath !== from.fullPath) {
    pageViewTracking.trackPageView(to);
  }

  next();
});

export default router;
